module.exports = __webpack_public_path__ + "img/logo-dark.af48fb81.png";